// frontend/src/components/ErrorMessage/ErrorMessage.jsx
import React from 'react';
import { useTranslation } from 'react-i18next'; // Import the hook
import './ErrorMessage.css';

const ErrorMessage = ({ message }) => {
  const { t } = useTranslation(); // Initialize the hook

  let displayMessage = "An unexpected error occurred.";

  if (typeof message === 'string') {
    // Handle old-style string messages for backward compatibility
    displayMessage = message;
  } else if (typeof message === 'object' && message !== null && message.key) {
    // Handle the new i18n object format
    const taskName = message.params?.taskKey ? t(`analysisTasks.${message.params.taskKey}`) : '';
    displayMessage = t(message.key, { ...message.params, taskName: taskName });
  }

  return (
    <div className="error-message-container">
      <p>{displayMessage}</p>
    </div>
  );
};

export default ErrorMessage;